export default __webpack_public_path__ + "static/media/FormBCertificate.d78eb8b0.png";